<template>
    <div style="height:100vh;background: #FFF;position: relative;">
		<div style="width: 100%;border-radius: 8px;overflow-y: scroll;">
			<div style="background: #fff;padding: 18px 18px 0 18px;box-sizing: border-box;border-radius: 8px;">
				<div style="display: flex;">
					<div style="display: flex;flex-direction: column; align-items: center;">
						<img :src="'https://spare4.qiyasoft.top/storage/547f3ed73176918cf0b834947a508e7e1709087162.png'" style="width: 32px;height: 32px;border-radius: 50%;">
						<div style="width: 38px;height: 16px;background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);border-radius: 4px;font-size: 12px;color: #fff;text-align: center;line-height: 16px;margin-top: -8px;">客户</div>
					</div>
					<div style="margin-left: 10px;">
						<div style="font-weight: 500;font-size: 16px;color: #333333;">{{saleInfo.customerName}}</div>
						<div style="font-weight: 500;font-size: 14px;color: #9A9B9E;margin-top: 3px;">序列号：{{saleInfo.serialNumber}}</div>
					</div>
				</div>
				<div style="padding: 10px 11px;background: #F7F7F7;border-radius: 6px;margin-top: 12px;font-weight: 500;font-size: 14px;color: #4B4D4D;line-height: 25px;">
					<div>产品名称：{{saleInfo.productName}}</div>
					<div>产品价格：{{saleInfo.productPrice}}</div>
					<div>规格型号：{{saleInfo.specModel}}</div>
					<!-- <div>电控单元/注油机：{{saleInfo.dkzyj}}</div> -->
					<!-- <div>销售/备用：{{saleInfo.sxby}}</div> -->
					<div>出厂日期：{{formatDate1(saleInfo.ccrq)}}</div>
					<!-- <div>机器序号：{{saleInfo.xh}}</div> -->
					<!-- <div>交付日期：{{formatDate(saleInfo.deliveryDate)}}</div> -->
					<div>质保年限：{{saleInfo.warrantyDate}}</div>
					<div>客户名称：{{saleInfo.customerName}}</div>
					<div>联系电话：{{saleInfo.customerMobile}}</div>
					<div>已维修次数：{{saleInfo.maintenance.length}}</div>
					<div>备注：{{saleInfo.remarks}}</div>
				</div>
				<div style="height: 44px;width: 100%;margin-top: 10px;display: flex;align-items: flex-end;">
					维修记录
				</div>
			</div>
		</div>
		<van-steps direction="vertical" :active="saleInfo.maintenance.length -1" v-if="saleInfo.maintenance.length!=0">
			<van-step v-for="(item,index) in saleInfo.maintenance" :key="item.id">
				<div>维修编号：WX-{{ formatDate2(item.maintenanceDate) }}-{{ index + 1 }}</div>
				<div style="padding: 10px 11px;background: #F7F7F7;border-radius: 6px;margin-top: 12px;font-weight: 500;font-size: 14px;color: #4B4D4D;line-height: 20px;">
					维修日期：{{ formatDate(item.maintenanceDate) }}
					<div>维修内容：{{item.maintenanceContent}}</div>
					<div>维修部件：{{item.maintenanceComp}}</div>
					<div>对接人：{{item.contactPerson}}</div>
					<div>联系电话：{{item.mobile}}</div>
					<div>备注：{{item.remarks}}</div>
				</div>
				<div style="display: flex;align-items: center;height: 44px;">
					<div style="width:100%;text-align: center;font-weight: 500;font-size: 14px;color: #333333;" @click="editSale(item)">修改</div>
					<div style="height: 30px;width: 2px;background: #F7F7F7;"></div>
					<div style="width:100%;text-align: center;font-weight: 500;font-size: 14px;color: red;" @click="delSale(item.id)">删除</div>
				</div>
			</van-step>
		</van-steps>
		<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;background: #fff;width: 100%;border-radius: 8px;" v-else>
			<!-- <img src="@/assets/undraw_empty_re_opql@2x.png" style="width:217px;height: 170px;"> -->
			<div style="font-family: PingFangSC, PingFang SC;font-style: normal;font-weight: 500;font-size: 16px;color: #333333;line-height: 26px;letter-spacing: 1px;text-align: center;display: flex;flex-direction: column; align-items: center;justify-content: center;line-height: 28px;">
				<div style="margin-top: 30px;">啊哦，暂无维修记录~</div>
			</div>
		</div>
		<div style="height: 100px;;"></div>
		
		<div class="share-url" @click="shareUrl">新增维修</div>
    </div>
</template>
<script>
import { Dialog,Steps } from 'vant';
import { user } from "@/api";
import dayjs from "dayjs";
import Index from './index.vue';

export default {
  data() {
    return {
		isNull: false,
		searchkey: '',
		saleInfo: null,
		hisList: [],
			pdfList: []
    };
  },
	mounted() {
		document.title = "维修记录";
		this.getHisList()
	},
	methods: {
		editSale(e) {
			this.$router.push({
				path:'/add-maintenance',
				query: {
					maintenance: JSON.stringify(e),
					id: this.saleInfo.id
				}
			})
		},
		delSale(e) {
			Dialog.confirm({
			title: '提醒',
			message: '确定删除该条记录吗？',
			})
			.then(() => {
				user.delMaintenance({id: e}).then(res=>{
					if(res.data.code == 200) {
						this.$toast.success('删除成功');
						this.getHisList()
					}
				})
			})
			.catch(() => {
				// on cancel
			});
		},
		shareUrl() {
			this.$router.push({
				path:'/add-maintenance',
				query: {
					id: this.saleInfo.id
				}
			})
		},
		goRecommend() {
			this.$router.back();
		},
		search(e) {
			console.log(e.target.value);
			this.searchkey = e.target.value;
			this.getHisList()
		},
		getHisList() {
			user.getSaleDetail({id: this.$route.query.id}).then(res => {
				if(res.data.code == 200) {
					this.saleInfo = res.data.data;
				}
			})
		},
		formatDate(e) {
			return dayjs(e).format('YYYY年MM月DD日');
		},
		formatDate1(e) {
			let ls = '20' + e
			return dayjs(ls).format('YYYY-MM-DD');
		},
		formatDate2(e) {
			return dayjs(e).format('YYMMDD');
		},
		jzgz(e) {
			this.$router.push({
				path:'/jzgzxx',
				query: {
					id: e
				}
			})
		}
	}
}
</script>
<style scoped>
::-webkit-scrollbar{
	display: none;
}
.ips{
	width: 92%;height: 32px;border: none;border-radius: 50px;padding: 0 15px;box-sizing: border-box;font-family: PingFang-SC, PingFang-SC;font-weight: 500;font-size: 12px;color: #4B4D4D;line-height: 20px;text-align: left;font-style: normal;
}
.top-bar-box {
	width: 100%;
	height: 44px;
	background: #fff;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	font-size: 15px;
	position: relative;
}
.sysc {
	width: 24px;
	height: 26px;
	position: absolute;
	right: 10px;
}
.top-bar {
	width: 100%;
	height: 44px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.top-bar-title {
	height: 41px;
	line-height: 41px;
}
.top-bar-line {
	width: 24px;
	height: 3px;
	border-radius: 10px;
}
.is-sel {
	color: #333333;
}
.no-sel {
	color: #9A9B9E;
}

.is-line-sel {
	background: #4873C0;
	animation: fadein 0.5s;
}
.no-line-sel {
	background: #fff;
	animation: fadeout 0.5s;
}
.share-url {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);
  line-height: 49px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  position: fixed;
  bottom: 10px;
  left: 0;
  cursor: pointer;
}
@keyframes fadeout {
    /*设置内容由显示变为隐藏*/
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes fadein {
    /*设置内容由隐藏变为显示*/
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
